/**
 * @generated SignedSource<<ca8b785a082a5be982694c4d54558909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainUnarchiveMutation$variables = {
  id: string;
};
export type RoutineEditMainUnarchiveMutation$data = {
  readonly routine: {
    readonly unarchiveRoutine: {
      readonly id: string;
      readonly isArchived: boolean;
    } | null;
  } | null;
};
export type RoutineEditMainUnarchiveMutation = {
  response: RoutineEditMainUnarchiveMutation$data;
  variables: RoutineEditMainUnarchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "unarchiveRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainUnarchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainUnarchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "34cb4aa7638d813dfbb50a47b7554133",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainUnarchiveMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainUnarchiveMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    unarchiveRoutine {\n      id\n      isArchived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55c7690593420c3bd2223508fd33174f";

export default node;
